<script>
import ButtonShowMore from '~/src/components/ui/Button/ButtonShowMore';
import ButtonShowLess from '~/src/components/ui/Button/ButtonShowLess';

export default {
    name: 'CollapsedText',
    props: {
        sneakPeak: {
            type: String,
            default: '',
        },
        mainText: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            expanded: false,
        };
    },
    methods: {
        toggleExpand() {
            this.expanded = !this.expanded;
        },
    },
    render(h) {
        const elements = [];
        const htmlWrapper = 'p';
        const transitionProps = {
            props: {
                name: 'fade',
            },
        };

        if (this.sneakPeak && this.sneakPeak.length) {
            elements.push(h(htmlWrapper, this.sneakPeak));
        }

        if (this.mainText && this.mainText.length) {
            const ButtonShowMoreElement = h(ButtonShowMore, {
                on: {
                    click: this.toggleExpand,
                },
                directives: [
                    {
                        name: 'show',
                        value: !this.expanded,
                    },
                ],
            });

            const ButtonShowLessElement = h(ButtonShowLess, {
                on: {
                    click: this.toggleExpand,
                },
                directives: [
                    {
                        name: 'show',
                        value: this.expanded,
                    },
                ],
            });

            const mainTextElement = h(htmlWrapper, {
                class: [
                    'collapsed-text_main-text',
                ],
                domProps: {
                    innerHTML: this.mainText,
                },
                directives: [
                    {
                        name: 'show',
                        value: this.expanded,
                    },
                ],
            });

            elements.push(
                h('Transition', transitionProps, [mainTextElement]),
                ButtonShowMoreElement,
                ButtonShowLessElement,
            );
        }

        return h('section', {}, elements);
    },
};
</script>

<style lang="scss">
    @import '~assets/css/transitions/fade.scss';
</style>
